"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnionTestBatchSortColumn = exports.TestBatchSortColumn = exports.SampleWithInstanceAndSpecSortColumn = exports.SampleSortColumn = exports.ClientOrganizationSortColumn = exports.ClientLicenseWithClientInfoTableSortColumn = exports.TempFilePasswordManagementTableSortColumn = exports.UserTableSortColumn = exports.ClientTableSortColumn = exports.OrderTableSortColumn = exports.ClientFilterOption = exports.SortOrder = void 0;
exports.isValidSortColumn = isValidSortColumn;
exports.isValidSortOrder = isValidSortOrder;
const database_1 = require("./database");
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
var ClientFilterOption;
(function (ClientFilterOption) {
    ClientFilterOption["MY_CLIENTS"] = "my-clients";
    ClientFilterOption["UNASSIGNED"] = "unassigned";
})(ClientFilterOption || (exports.ClientFilterOption = ClientFilterOption = {}));
var OrderTableSortColumn;
(function (OrderTableSortColumn) {
    OrderTableSortColumn["BARCODE_ID"] = "barcodeId";
    OrderTableSortColumn["INSERTED"] = "inserted";
})(OrderTableSortColumn || (exports.OrderTableSortColumn = OrderTableSortColumn = {}));
var ClientTableSortColumn;
(function (ClientTableSortColumn) {
    ClientTableSortColumn["INSERTED"] = "inserted";
    ClientTableSortColumn["EMAIL"] = "email";
    ClientTableSortColumn["FIRST_NAME"] = "firstName";
    ClientTableSortColumn["LAST_NAME"] = "lastName";
    ClientTableSortColumn["CLIENT_COMPANY_NAME"] = "clientCompanyName";
})(ClientTableSortColumn || (exports.ClientTableSortColumn = ClientTableSortColumn = {}));
var UserTableSortColumn;
(function (UserTableSortColumn) {
    UserTableSortColumn["INSERTED"] = "inserted";
    UserTableSortColumn["USER_NAME"] = "userName";
    UserTableSortColumn["ROLE"] = "role";
    UserTableSortColumn["FIRST_NAME"] = "firstName";
    UserTableSortColumn["LAST_NAME"] = "lastName";
})(UserTableSortColumn || (exports.UserTableSortColumn = UserTableSortColumn = {}));
var TempFilePasswordManagementTableSortColumn;
(function (TempFilePasswordManagementTableSortColumn) {
    TempFilePasswordManagementTableSortColumn["INSERTED"] = "inserted";
    TempFilePasswordManagementTableSortColumn["NAME"] = "name";
    TempFilePasswordManagementTableSortColumn["LAST_UPDATED"] = "lastUpdated";
})(TempFilePasswordManagementTableSortColumn || (exports.TempFilePasswordManagementTableSortColumn = TempFilePasswordManagementTableSortColumn = {}));
var ClientLicenseWithClientInfoTableSortColumn;
(function (ClientLicenseWithClientInfoTableSortColumn) {
    ClientLicenseWithClientInfoTableSortColumn["INSERTED"] = "license.inserted";
    ClientLicenseWithClientInfoTableSortColumn["LICENSE_NUMBER"] = "license.licenseNumber";
    ClientLicenseWithClientInfoTableSortColumn["CLIENT_COMPANY_NAME"] = "client.clientCompanyName";
    ClientLicenseWithClientInfoTableSortColumn["CLIENT_FIRST_NAME"] = "client.firstName";
    ClientLicenseWithClientInfoTableSortColumn["CLIENT_LAST_NAME"] = "client.lastName";
})(ClientLicenseWithClientInfoTableSortColumn || (exports.ClientLicenseWithClientInfoTableSortColumn = ClientLicenseWithClientInfoTableSortColumn = {}));
var ClientOrganizationSortColumn;
(function (ClientOrganizationSortColumn) {
    ClientOrganizationSortColumn["INSERTED"] = "co.inserted";
    ClientOrganizationSortColumn["CLIENT_COMPANY_NAME"] = "co.clientCompanyName";
    ClientOrganizationSortColumn["ASSOCIATION_ID"] = "co.associationId";
})(ClientOrganizationSortColumn || (exports.ClientOrganizationSortColumn = ClientOrganizationSortColumn = {}));
var SampleSortColumn;
(function (SampleSortColumn) {
    SampleSortColumn["FULL_SAMPLE_ID"] = "fullSampleId";
    SampleSortColumn["INSERTED"] = "inserted";
    SampleSortColumn["SAMPLE_NAME"] = "sampleName";
    SampleSortColumn["LOT_CODE"] = "lotCode";
})(SampleSortColumn || (exports.SampleSortColumn = SampleSortColumn = {}));
var SampleWithInstanceAndSpecSortColumn;
(function (SampleWithInstanceAndSpecSortColumn) {
    SampleWithInstanceAndSpecSortColumn["EXPECTED_COMPLETION_TIME"] = "csi.expectedCompletionTime";
    SampleWithInstanceAndSpecSortColumn["SAMPLE_ID"] = "cs.fullSampleId";
})(SampleWithInstanceAndSpecSortColumn || (exports.SampleWithInstanceAndSpecSortColumn = SampleWithInstanceAndSpecSortColumn = {}));
var TestBatchSortColumn;
(function (TestBatchSortColumn) {
    TestBatchSortColumn["DUE_DATE"] = "stb.dueDate";
    TestBatchSortColumn["INSERTED"] = "stb.inserted";
})(TestBatchSortColumn || (exports.TestBatchSortColumn = TestBatchSortColumn = {}));
var UnionTestBatchSortColumn;
(function (UnionTestBatchSortColumn) {
    UnionTestBatchSortColumn["DUE_DATE"] = "stb_dueDate";
    UnionTestBatchSortColumn["INSERTED"] = "stb_inserted";
})(UnionTestBatchSortColumn || (exports.UnionTestBatchSortColumn = UnionTestBatchSortColumn = {}));
function isValidSortColumn(enumObj, value) {
    return Object.values(enumObj).includes(value);
}
function isValidSortOrder(order) {
    return Object.values(SortOrder).includes(order);
}
